<template>
  <div>
    <div v-if="mapLoaded">
      <GmapMap
        ref="mapRef"
        :center="myCenter"
        :zoom="zoom"
        map-type-id="terrain"
        :style="'width: ' + width + 'px; height: ' + height + 'px;'"
        class="size"
      >
        <gmap-custom-marker :marker="myCenter" :z-index="10">
          <div @click="click(myCenter)" class="is-gant hover-item speech-bubble" style="border-radius: 3px; color: white; text-align: center;">
            <b-icon style="margin: 2px;" type="is-white" size="is-medium" :icon="type"></b-icon>
          </div>
        </gmap-custom-marker>
      </GmapMap>
    </div>
    <div v-else class="loading-container">
      <b-loading :is-full-page="false" :active="!mapLoaded"></b-loading>
    </div>
  </div>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import GoogleMapsService from '@/services/GoogleMapsService.js';

export default {
  name: 'GMap',
  components: {
    'gmap-custom-marker': GmapCustomMarker,
  },
  data: function () {
    return {
      myCenter: { lat: 45.508, lng: -73.587 },
      selectedHotel: {},
      selectedCar: {},
      type: null,
      routeName: this.$route.name,
      picWidth: 55,
      mapLoaded: false,
      map: null
    }
  },
  props: {
    lat: Number,
    long: Number,
    image: String,
    name: String,
    description: String,
    width: String,
    height: String,
    carOrHotel: String,
    zoom: {
      type: Number,
      default: 12
    }
  },
  methods: {
    getCenter() {
      this.myCenter = { lat: this.lat, lng: this.long };
    },
    click(pos) {
      if (this.map) {
        this.map.setZoom(15);
        this.map.panTo(pos);
      }
    },
    async initMap() {
      try {
        // Ensure Google Maps is loaded
        await GoogleMapsService.load();
        this.mapLoaded = true;
        
        // Wait for the map to be rendered
        this.$nextTick(() => {
          if (this.$refs.mapRef) {
            this.$refs.mapRef.$mapPromise.then((map) => {
              this.map = map;
            });
          }
        });
      } catch (error) {
        console.error('Failed to load Google Maps:', error);
      }
    }
  },
  async mounted() {
    this.getCenter();
    await this.initMap();
    
    this.selectedHotel = this.$store.state.bookTravel.result.hotel;
    this.selectedCar = this.$store.state.bookTravel.result.car;
    
    if (this.$route.name == 'cars') {
      this.selectedCar = {};
      this.type = 'car';
      this.picWidth = "60";
    }
    else if (this.$route.name == 'hotels') {
      this.selectedHotel = {};
      this.type = 'bed';
      this.picWidth = "100";
    }
    else {
      this.type = this.carOrHotel;
    }
  }
}
</script>

<style>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 300px;
}

.speech-bubble {
  position: relative;
  border-radius: .4em;
  background-color: #ab323b;
}
.speech-bubble:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top-color: #ab323b;
  border-bottom: 0;
  margin-left: -5px;
  margin-bottom: -5px;
}
@media screen and (max-width: 1023px) {
  .size {
    width: 100vw !important;
    height: 100vw !important;
    margin: auto !important;
  }
}
</style>
